import React from 'react';

const RoleComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">What was your role at the company?</h1>
      <p className="alt-text">Try to answer these key questions:</p>
      <ul className="categoried-list">
        <li>Think of the mark you left on the company. What specific, measurable results were accomplished because you were in that position and not somebody else?</li>
        <li>Remember, you stand out best when you highlight your accomplishments rather than your responsibilities.</li>
        <li>Feel free to leave this blank if your role is sufficiently explained by your project descriptions.</li>
      </ul>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">What was your role at the company?</p>
        <ul className="categoried-list">
          <li>Led a team of 6 software engineers, delegrating tasks in weekly sprints and running daily standups.</li>
          <li>Worked closely with Product Managers, UX team, and business managers to strategize product design and implementation.</li>
          <li>Interviewed 30+ prospective employees and mentored junior software developers on the team.</li>
        </ul>
      </div>
    </div>
  );
};

export default RoleComponent;
